// import React, { useState, useEffect } from "react";
// import { Tabs, Card, Row, Col, Spin, Form, Select, Button } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import { fetchCashlesshospitalData } from "../../Action/Actions";
// import { useSelectedYear } from "../../Context/SelectYearContext";
// import { getUserData } from "../login/LoginSlice";
// import CashlessData from "./CashlessData";
// import { ExportOutlined, UserOutlined, TeamOutlined } from "@ant-design/icons";
// import { saveAs } from "file-saver";
// import "./cash.css";

// const Index = () => {
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const AuthData = useSelector(getUserData);
//   const [activeTab, setActiveTab] = useState("GMC");
//   const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
//   const { selectedYear } = useSelectedYear();
//   const [escalationData, setEscalationData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [filterData, setFilterData] = useState([]);
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });
//   const [selectedState, setSelectedState] = useState(null);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [stateData, setStateData] = useState([]);
//   const [cityData, setCityData] = useState({});
//   const user = useSelector(getUserData);

//   const Id = AuthData?.corporate_id;

//   useEffect(() => {
//     document.title = `Cashless Hospitals`;
//     fetchCashless();
//   }, []);

//   useEffect(() => {
//     if (activeTab && escalationData[activeTab]) {
//       const firstPolicyNumber = escalationData[activeTab]?.[0]?.policy_number;
//       setSelectedPolicyNumber(firstPolicyNumber || null);
//     }
//   }, [activeTab, escalationData]);

//   useEffect(() => {
//     if (selectedPolicyNumber) {
//       const selectedPolicy = escalationData[activeTab]?.find(
//         (policy) => policy.policy_number === selectedPolicyNumber
//       );
//       setFilterData(selectedPolicy?.cashless_hospitals || []);
//     }
//   }, [selectedPolicyNumber, activeTab, escalationData]);

//   const fetchCashless = async () => {
//     try {
//       setLoading(true);
//       const response = await dispatch(fetchCashlesshospitalData(Id));
//       const policyData = response?.Cashless_hospitals_list || {};

//       const filteredPolicyData = {
//         GMC: policyData.GMC || [],
//         GTL: policyData.GTL || [],
//       };

//       setEscalationData(filteredPolicyData);

//       const allHospitals = Object.values(filteredPolicyData).flatMap(policyArray =>
//         policyArray.flatMap(policy => policy.cashless_hospitals || [])
//       );
//       const states = [...new Set(allHospitals.map(hospital => hospital.state))];
//       const cities = states.reduce((acc, state) => {
//         acc[state] = [...new Set(allHospitals.filter(hospital => hospital.state === state).map(hospital => hospital.city))];
//         return acc;
//       }, {});
//       setStateData(states);
//       setCityData(cities);

//       const firstPolicyNumber = filteredPolicyData[activeTab]?.[0]?.policy_number;
//       setSelectedPolicyNumber(firstPolicyNumber || null);
//     } catch (error) {
//       console.error("Error fetching policies:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredData = filterData.filter((hospital) => {
//     const matchesState = selectedState ? hospital.state === selectedState : true;
//     const matchesCity = selectedCity ? hospital.city === selectedCity : true;
//     return matchesState && matchesCity;
//   });

//   const getTabIcon = (type) => {
//     switch (type) {
//       case "GMC":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "GTL":
//         return <UserOutlined style={{ marginRight: 8 }} />;
//       default:
//         return null;
//     }
//   };

//   const items = ["GMC", "GTL"].map((key) => ({
//     key,
//     label: (
//       <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//         {key}
//         {getTabIcon(key)}
//       </span>
//     ),
//     children: (
//       <Tabs
//         defaultActiveKey={escalationData[key]?.[0]?.policy_number}
//         items={escalationData[key]?.map((policy) => ({
//           key: policy.policy_number,
//           label: policy.policy_number,
//         }))}
//         onChange={(policyNumber) => {
//           setSelectedPolicyNumber(policyNumber);
//         }}
//       />
//     ),
//   }));

//   const handleTabChange = (key) => {
//     setActiveTab(key);
//   };

//   const handleTableChange = (newPagination) => {
//     setPagination({
//       current: newPagination.current,
//       pageSize: newPagination.pageSize,
//       total: pagination.total,
//     });
//   };

//   const paginatedData = filteredData.slice(
//     (pagination.current - 1) * pagination.pageSize,
//     pagination.current * pagination.pageSize
//   );

//   const handleStateChange = (value) => {
//     setSelectedState(value);
//     setSelectedCity(null);
//   };

//   const handleCityChange = (city) => {
//     setSelectedCity(city);
//   };

//   const handleExport = () => {
//     const dataToExport = paginatedData.map((data, index) => ({
//       No: index + 1,
//       Hospital: data.hospital_name || "N/A",
//       Address: data.address || "N/A",
//       State: data.state || "N/A",
//       City: data.city || "N/A",
//       OtherDetails: data.otherDetails || "N/A",
//     }));

//     const csvContent = [
//       ["No", "Hospital", "Address", "State", "City", "OtherDetails"],
//       ...dataToExport.map((item) =>
//         Object.values(item).map((value) => `"${value}"`)
//       ),
//     ]
//       .map((row) => row.join(","))
//       .join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, `Cashless_Hospitals_${selectedYear}.csv`);
//   };

//   return (
//     <Spin spinning={loading}>
//       <div className="escalation-matrix-container">
//         <div className="escalation-heading">Cashless Hospital</div>
//         <div className="escalation-content">
//           <Row className="escalation-row-header">
//             <span style={{ fontWeight: "700", fontSize: "20px" }}>
//               {user?.fullname || "Guest"}
//             </span>{" "}
//             (Financial Year: {selectedYear})
//           </Row>
//         </div>
//         <Tabs
//           activeKey={activeTab}
//           onChange={handleTabChange}
//           className="esc-tab"
//           items={items}
//         />
//         <div className="cash-form-bg">
//           <Card>
//             <Form form={form} layout="vertical">
//               <Row gutter={16} className="mb-3 justify-content-between align-items-center px-3">
//                 <Col xs={24} sm={6} md={6} lg={6} xl={6} className="px-0">
//                   <Form.Item
//                     label="Hospital State"
//                     name="hospital_state"
//                     rules={[{ required: true, message: "Please select Hospital State" }]}
//                   >
//                     <Select
//                       placeholder="Hospital State"
//                       options={stateData.map((state) => ({
//                         value: state,
//                         label: state,
//                       }))}
//                       onChange={handleStateChange}
//                     />
//                   </Form.Item>
//                 </Col>

//                 {selectedState !== null && (
//                   <Col xs={24} sm={6} md={6} lg={6} xl={6}>
//                     <Form.Item
//                       label="Hospital City"
//                       name="hospital_city"
//                       rules={[{ required: true, message: "Please select Hospital City" }]}
//                     >
//                       <Select
//                         placeholder="Hospital City"
//                         options={cityData[selectedState]?.map((city) => ({
//                           value: city,
//                           label: city,
//                         }))}
//                         onChange={handleCityChange}
//                       />
//                     </Form.Item>
//                   </Col>
//                 )}

//                 <Col xs={24} sm={6} md={6} lg={6} xl={6}>
//                   <Button
//                     type="primary"
//                     icon={<ExportOutlined />}
//                     onClick={handleExport}
//                     disabled={paginatedData.length === 0}
//                     className="d-flex"
//                   >
//                     Export
//                   </Button>
//                 </Col>
//               </Row>
//             </Form>

//             <CashlessData
//               loading={loading}
//               filteredData={paginatedData}
//               pagination={{
//                 current: pagination.current,
//                 pageSize: pagination.pageSize,
//                 total: filteredData.length,
//                 showSizeChanger: true,
//                 pageSizeOptions: ["10", "20", "50", "100"],
//                 onChange: (page, pageSize) =>
//                   handleTableChange({ current: page, pageSize }),
//                 showTotal: (total, range) =>
//                   `Showing ${range[0]} to ${range[1]} of ${total} entries`,
//               }}
//             />
//           </Card>
//         </div>
//       </div>
//     </Spin>
//   );
// };

// export default Index;

import React, { useState, useEffect } from "react";
import { Tabs, Card, Row, Col, Spin, Form, Select, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchCashlesshospitalData } from "../../Action/Actions";
import { getUserData } from "../login/LoginSlice";
// ADDED: Import selectors from your Redux financial year slice
import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice";
import CashlessData from "./CashlessData";
import { ExportOutlined, UserOutlined, TeamOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import "./cash.css";

const RESTRICTED_POLICY_TYPE_IDS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

const Index = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const user = useSelector(getUserData);

  // UPDATED: Get user and financial year details from Redux
  const Id = user?.corporate_id;
  const selectedYearId = useSelector(selectSelectedYearId);
  const yearList = useSelector(selectFinancialYears);
  
  // DERIVED STATE: Find the display name for the selected year
  const selectedYear = yearList.find(year => year.id === selectedYearId)?.financial_year || "";

  const [activeTab, setActiveTab] = useState(null);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [escalationData, setEscalationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState({});

  const fetchCashless = async () => {
    // Guard clause: Don't fetch if required IDs are missing
    if (!Id || !selectedYearId) {
      setEscalationData({}); // Clear previous data
      return;
    }
    try {
      setLoading(true);
      // The thunk now gets financialYearId from the store internally
      const response = await dispatch(fetchCashlesshospitalData(Id));
      const policyData = response?.Cashless_hospitals_list || {};

      // Filter out restricted policy types
      const filteredPolicyData = {};
      Object.keys(policyData).forEach((type) => {
        const validPolicies = (policyData[type] || []).filter((p) => {
          // Check for policy_type_id in various possible locations in the object structure
          const details = Array.isArray(p.policy_details) ? p.policy_details[0] : p.policy_details;
          const ptId = Number(p.policy_type_id || p.Policy_Type_id || details?.policy_type_id);
          return !RESTRICTED_POLICY_TYPE_IDS.includes(ptId);
        });

        if (validPolicies.length > 0) {
          filteredPolicyData[type] = validPolicies;
        }
      });

      setEscalationData(filteredPolicyData);

      // Process the response to populate state/city dropdowns
      const allHospitals = Object.values(filteredPolicyData).flatMap(policyArray =>
        policyArray.flatMap(policy => policy.cashless_hospitals || [])
      );
      const states = [...new Set(allHospitals.map(hospital => hospital.state).filter(Boolean))].sort();
      const cities = states.reduce((acc, state) => {
        acc[state] = [...new Set(allHospitals.filter(hospital => hospital.state === state).map(hospital => hospital.city).filter(Boolean))].sort();
        return acc;
      }, {});
      
      setStateData(states);
      setCityData(cities);

      // Set the first available tab and policy as active
      const firstTab = Object.keys(policyData)[0] || null;
      setActiveTab(firstTab);

      if (firstTab) {
        const firstPolicy = policyData[firstTab]?.[0];
        const firstPolicyNumber = firstPolicy?.policy_number !== undefined ? firstPolicy.policy_number : (firstPolicy?.policy_id || null);
        setSelectedPolicyNumber(firstPolicyNumber);
      } else {
        setSelectedPolicyNumber(null);
      }

    } catch (error) {
      console.error("Error fetching policies:", error.message);
      setEscalationData({}); // Clear data on error
    } finally {
      setLoading(false);
    }
  };
  
  // UPDATED: useEffect now depends on corporateId and selectedYearId
  useEffect(() => {
    document.title = `Cashless Hospitals`;
    fetchCashless();
  }, [Id, selectedYearId, dispatch]);

  // This effect correctly sets the list of hospitals when a policy is selected
  useEffect(() => {
    if (activeTab && selectedPolicyNumber !== null && escalationData[activeTab]) {
      const selectedPolicy = escalationData[activeTab].find(
        (policy) => {
          const key = policy.policy_number || policy.policy_id || "";
          return key === selectedPolicyNumber;
        }
      );
      setFilterData(selectedPolicy?.cashless_hospitals || []);
    } else {
      setFilterData([]);
    }
  }, [selectedPolicyNumber, activeTab, escalationData]);

  const filteredByDropdowns = filterData.filter((hospital) => {
    const matchesState = selectedState ? hospital.state === selectedState : true;
    const matchesCity = selectedCity ? hospital.city === selectedCity : true;
    return matchesState && matchesCity;
  });

  const getTabIcon = (type) => {
    switch (type) {
      case "GMC": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL": return <UserOutlined style={{ marginRight: 8 }} />;
      default: return null;
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    // When top tab changes, select the first policy number within that new tab
    const firstPolicy = escalationData[key]?.[0];
    const firstPolicyNumber = firstPolicy?.policy_number !== undefined ? firstPolicy.policy_number : (firstPolicy?.policy_id || null);
    setSelectedPolicyNumber(firstPolicyNumber);
    form.resetFields(); // Reset filters
    setSelectedState(null);
    setSelectedCity(null);
  };
  
  const handlePolicyNumberChange = (policyNumber) => {
    setSelectedPolicyNumber(policyNumber);
    form.resetFields(); // Reset filters
    setSelectedState(null);
    setSelectedCity(null);
  };
  
  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedCity(null);
    form.setFieldsValue({ hospital_city: null }); // Reset city field in the form
  };

  const handleCityChange = (city) => {
    setSelectedCity(city);
  };
  
  const handleExport = () => {
    const dataToExport = filteredByDropdowns.map((data, index) => ({
      No: index + 1,
      Hospital: data.hospital_name || "N/A",
      Address: data.address || "N/A",
      State: data.state || "N/A",
      City: data.city || "N/A",
      OtherDetails: data.otherDetails || "N/A",
    }));

    const csvContent = [
      ["No", "Hospital", "Address", "State", "City", "OtherDetails"],
      ...dataToExport.map((item) =>
        Object.values(item).map((value) => `"${String(value).replace(/"/g, '""')}"`)
      ),
    ]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `Cashless_Hospitals_${selectedYear}.csv`);
  };

  const mainTabItems = Object.keys(escalationData).map((type) => ({
    key: type,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {getTabIcon(type)}
        {type}
      </span>
    ),
    children: (
      <Tabs
        activeKey={selectedPolicyNumber !== null ? String(selectedPolicyNumber) : undefined}
        onChange={handlePolicyNumberChange}
        items={escalationData[type]?.map((policy, index) => {
          const key = policy.policy_number !== undefined ? policy.policy_number : (policy.policy_id || `policy-${index}`);
          return {
            key: String(key),
            label: policy.policy_number ? (
              policy.policy_number
            ) : (
              <span
                style={{
                  backgroundColor: "#FFFF00",
                  color: "#000000E0",
                  padding: "2px 8px",
                  fontSize: "12px",
                  fontFamily: '"Plus Jakarta Sans", sans-serif',
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              >
                Policy Number not issued
              </span>
            ),
          };
        })}
      />
    ),
  }));

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-heading">Cashless Hospital</div>
        <div className="escalation-content">
          <Row className="escalation-row-header">
            <span style={{ fontWeight: "700", fontSize: "20px" }}>
              {user?.corporate_name || "Guest"}
            </span>
            <span style={{ marginLeft: "8px" }}>
              (Financial Year: {selectedYear})
            </span>
          </Row>
        </div>

        {mainTabItems.length > 0 ? (
          <>
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              className="esc-tab"
              items={mainTabItems}
            />

            <div className="cash-form-bg">
          <Card>
            <Form form={form} layout="vertical">
              <Row gutter={16} align="bottom">
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="Hospital State" name="hospital_state">
                    <Select
                      placeholder="Select State"
                      options={stateData.map((state) => ({ value: state, label: state }))}
                      onChange={handleStateChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="Hospital City" name="hospital_city">
                    <Select
                      placeholder="Select City"
                      options={cityData[selectedState]?.map((city) => ({ value: city, label: city })) || []}
                      onChange={handleCityChange}
                      disabled={!selectedState}
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                   <Form.Item>
                      <Button
                        type="primary"
                        icon={<ExportOutlined />}
                        onClick={handleExport}
                        disabled={filteredByDropdowns.length === 0}
                      >
                        Export
                      </Button>
                   </Form.Item>
                </Col>
              </Row>
            </Form>

            <CashlessData
              loading={loading}
              filteredData={filteredByDropdowns}
              pagination={{
                ...pagination,
                total: filteredByDropdowns.length,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              }}
              onTableChange={(newPagination) => {
                setPagination({
                  current: newPagination.current,
                  pageSize: newPagination.pageSize,
                });
              }}
            />
          </Card>
        </div>
          </>
        ) : (
          <Card style={{ marginTop: "20px" }}>
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p style={{ fontSize: "16px", fontWeight: "500" }}>No cashless hospital data available for {selectedYear}</p>
            </div>
          </Card>
        )}
      </div>
    </Spin>
  );
};

export default Index;